import { createBrowserHistory } from 'history';

/**
 * Browser history instance
 *
 * @type {Object}
 */
export const history = createBrowserHistory();
